import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import { Tab, Row, Col, Nav, Carousel } from 'react-bootstrap'
import { useState } from 'react'

const AdultList = props => {
  const { data,
    handleSelectA,
    handleSelectB,
    handleSelectC,
    indexA,
    indexB,
    indexC,
  } = props
  return (
      <Row className="list">
        <Col sm={12} md={12} lg={4} className="my-3">
          <Carousel interval={null} activeIndex={indexA} onSelect={handleSelectA} indicators={false} wrap={false}>
            {
              data.mae.edges.map((el, i) => (
                <Carousel.Item key={i}>
                  <Img
                    fluid={el.node.childImageSharp.fluid}
                    alt={"D&A" + i}
                  />
                </Carousel.Item>

              ))
            }
          </Carousel>
        </Col>

        <Col sm={12} md={12} lg={4} className="my-3">
          <Carousel interval={null} activeIndex={indexB} onSelect={handleSelectB} indicators={false} wrap={false}>
            {
              data.tequila.edges.map((el, i) => (
                <Carousel.Item key={i}>
                  <Img
                    fluid={el.node.childImageSharp.fluid}
                    alt={"D&A" + i}
                  />
                </Carousel.Item>

              ))
            }
          </Carousel>
        </Col>

        <Col sm={12} md={12} lg={4} className="my-3">
          <Carousel interval={null} activeIndex={indexC} onSelect={handleSelectC} indicators={false} wrap={false}>
            {
              data.terrores.edges.map((el, i) => (
                <Carousel.Item key={i}>
                  <Img
                    fluid={el.node.childImageSharp.fluid}
                    alt={"D&A" + i}
                  />
                </Carousel.Item>

              ))
            }
          </Carousel>
        </Col>
      </Row>
  )
}
const OA = () => {
  const imageData = useStaticQuery(graphql`
  query HQsOA {
    aqua: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "aqua"}}) {
      edges {
        node {
          childImageSharp {
            fluid (quality: 90) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
      }
    }
    mae: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "mae"}}, sort: {fields: name}) {
      edges {
        node {
          childImageSharp {
            fluid (quality: 90) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
      }
    }
    tequila: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "tequila"}}, sort: {fields: name}) {
      edges {
        node {
          childImageSharp {
            fluid (quality: 90) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
      }
    }
    terrores: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "terrores"}}, sort: {fields: name}) {
      edges {
        node {
          childImageSharp {
            fluid (quality: 90) {
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
      }
    }
  }
  
    `
  )
  const [indexA, setIndexA] = useState(0)
  const [indexB, setIndexB] = useState(0)
  const [indexC, setIndexC] = useState(0)

  const handleSelectA = (selectedIndex, e) => {
    setIndexA(selectedIndex)
  }
  const handleSelectB = (selectedIndex, e) => {
    setIndexB(selectedIndex)
  }
  const handleSelectC = (selectedIndex, e) => {
    setIndexC(selectedIndex)
  }

  return (
    <div className="mt-2" id="carousel">
      <p className="font-weight-normal">
        Além de escrever, às vezes me arrisco em outras formas de expressão. Aqui você vê desde um projeto de quadrinhos - chamado Adultologia - a aquarelas e técnicas mistas.
            </p>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col md={3} lg={2}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">Desenhos & Aquarela</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Adultologia</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Row>
                  {
                    imageData.aqua.edges.map((el, i) => (
                      <Col className="text-center" sm={12} md={6} lg={4} key={i}>
                        <Img
                          fluid={el.node.childImageSharp.fluid}
                          alt={"D&A" + i}
                          className="m-1"
                        />
                      </Col>
                    ))
                  }
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <AdultList
                  data={imageData}
                  handleSelectA={handleSelectA} indexA={indexA}
                  handleSelectB={handleSelectB} indexB={indexB}
                  handleSelectC={handleSelectC} indexC={indexC}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  )
}

export default OA
